module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mmsbnp2-1a2abcefa8a888a040f53a64ea9ae945.jpg";